import * as React from "react";

import Progress from "../../../common/organism/progress";

import { Project } from "../../../../domain/model/project";
import { Customer } from "../../../../domain/model/customer";
import { Contract } from "../../../../domain/model/contract";
import ClientContractMainEditForm from "./edit/client_contract_main_edit_form";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import ProjectThumbnail from "./share/project_thumbnail";
import { TBreadcrumbItem } from "../../../type/common";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import { entity } from "../../../../infra/api/rpc/api";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  project: Project | null;
  customer: Customer | null;
  contract: Contract | null;
  handleUpdateSubmit: (values: any) => void;
  handleApprove: (contract: Contract) => void;
}

const ClientContractEditComponent: React.FC<IProps> = (props) => {
  const {
    isLoading,
    project,
    customer,
    contract,
    handleUpdateSubmit,
    handleApprove,
  } = props;

  const initialValues = {
    project,
    customer,
    contract,
  };

  if (!project) {
    return <div />;
  }

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    { text: `[成約報告]${project.name}` },
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        <ProjectThumbnail project={project} />
        <ClientContractMainEditForm
          initialValues={initialValues}
          onSubmit={handleUpdateSubmit}
          enableReinitialize={true}
        />

        {!contract!.isApproved &&
          contract!.requester ===
            entity.Contract.Requester.Requester_Customer && (
            <SubmitButtonWrapper
              onClick={() => {
                handleApprove(contract!);
              }}
            >
              <BtnCorporateLarge type="submit" widthSize="200px">
                承認する
              </BtnCorporateLarge>
            </SubmitButtonWrapper>
          )}
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientContractEditComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/client_contract_edit.tsx